import { Input, Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiDataService, IApiResultObject } from './services/api-data.service';
import { FormControl, FormGroup, Validator, Validators } from "@angular/forms"
import { setInterval } from 'timers';
//declare function showMessageDlg(title: string, body: string, okLabel: string, onOk: any, cancelLabel: string, onCancel: any): any;
declare function ajaxLoaderStart(): any;
declare function ajaxLoaderEnd(): any;

@Component({
    selector: 'login',
    template: require('./app.component.login.html'),
    styles: [require('./app.component.login.css')],
    providers: [ApiDataService]
})
export class AppComponent {
    private returnUrl: string;
    private culture: string = 'uk';

    private passwordType: string = 'password';
    private newPasswordType: string = 'password';

    private isShowError: boolean = false;   
    private isShowSuccess: boolean = false;

    private isRecoverFormSuccess: boolean = false;

    private isLoginValid: boolean = true;
    private result: IApiResultObject = null;
    loginForm: FormGroup;
    recoverForm: FormGroup;
    sendCodeForm: FormGroup;
    newPasswordForm: FormGroup;

    private isLoginFormShow: boolean = true;
    private isRecoverFormShow: boolean = false;
    private isSendCodeFormShow: boolean = false;
    private isNewPasswordFormShow: boolean = false;

    private isUserNameEmail: boolean = true;

    private sendCodeResult: IApiResultObject = null;
    private checkCodeResult: IApiResultObject = null;

    private code: string = "00000";

    private timeLeft: number = 30;
    private secondsLeft = '0:30';

    private isShowCountSmsError: boolean = false;
    private isShowSendSmsTryLaterError: boolean = false;

    private isShowCodeInvalidCountError: boolean = false;
    private isShowCodeInvalidError: boolean = false;
    private isShowCodeTryLaterError: boolean = false;

    private phone: string = "";

    constructor(private translate: TranslateService, private apiDataService: ApiDataService, private elementRef: ElementRef) {
        this.culture = this.elementRef.nativeElement.getAttribute('culture');
        this.returnUrl = this.elementRef.nativeElement.getAttribute('returnUrl');
        let token: string = this.elementRef.nativeElement.getAttribute('token');
        if (token != null) {
            this.checkCodeResult = {
                message: token
            } as IApiResultObject;
           this.goToSetPassword();
        }
        
        translate.setDefaultLang(this.culture);  
        this.loginForm = new FormGroup({
            "UserName": new FormControl("", Validators.required),
            "Password": new FormControl("", Validators.required),
            "RememberMe": new FormControl("", null)/*,
            "phone": new FormControl("", Validators.pattern("[0-9]{10}")),
            "email": new FormControl("", [Validators.required, Validators.email]),
            "password": new FormControl("", Validators.required),
            "confirmPassword": new FormControl("", Validators.required)*/
        });
        this.loginForm.get('RememberMe').setValue(false);

        this.recoverForm = new FormGroup({
            "UserName": new FormControl("", Validators.required)
        });

        this.sendCodeForm = new FormGroup({
        });

        this.newPasswordForm = new FormGroup({
            "Password": new FormControl("", [Validators.required, Validators.minLength(6)])
        });
    }

    ngOnInit(): void {
        
    }

    goToRememberPassword(): void {
        this.isLoginFormShow = false;
        this.isRecoverFormShow = true;
        this.isSendCodeFormShow = false;
        this.isNewPasswordFormShow = false;
    }

    goTologin(): void {
        this.isRecoverFormShow = false;
        this.isLoginFormShow = true;
        this.isSendCodeFormShow = false;
        this.isNewPasswordFormShow = false;
    }

    goToCheckCode(): void {
        this.isRecoverFormShow = false;
        this.isSendCodeFormShow = true;
    }

    goToSetPassword(): void {
        this.isLoginFormShow = false;
        this.isSendCodeFormShow = false;
        this.isNewPasswordFormShow = true;
    }

    onUserNameChange(userName: string): void {
        this.phone = userName.replace(/\+38/gi, "").replace(/\(/gi, "").replace(/\)/gi, "").replace(/-/gi, "").replace(/ /gi, "");
        if (new RegExp(/^\d+$/).test(this.phone) && this.phone.length == 10) {
            this.isUserNameEmail = false;
        }
        else {
            this.isUserNameEmail = true;
            this.phone = "";
        }
    }

    startTimer(): void {
        this.timeLeft = 30;
        this.secondsLeft = "0:30";
        this.interval();
    }

    interval(): void {
        setTimeout(() => {
            this.timeLeft--;
            let tostr = (number: number) => (number <= 9 ? "0:0" + number.toString() : "0:" + number.toString());
            this.secondsLeft = tostr(this.timeLeft);
            if (this.timeLeft > 0) {
                this.interval();
            }
        }, 1000);
    }

    sendSmsWithCode(): void {
        let data = {
            phone: this.phone
        };
        ajaxLoaderStart();
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/ResetPasswordSendCode", data)
            .subscribe(d => {
                ajaxLoaderEnd();
                console.log(d);
                this.sendCodeResult = d as IApiResultObject;
                if (this.sendCodeResult.status == true) {
                    this.startTimer();
                    if (this.sendCodeResult.data == -1)
                        this.isShowCountSmsError = true;
                    else if (this.sendCodeResult.data == 0)
                        this.isShowSendSmsTryLaterError = true;
                    else
                        this.goToCheckCode();
                }
                else {
                    this.isShowSendSmsTryLaterError = true;
                }  
            });
    }

    onShowPasswordClick() : void {
        if (this.passwordType === 'password')
            this.passwordType = 'text';
        else
            this.passwordType = 'password';
    }

    onShowNewPasswordClick(): void {
        if (this.newPasswordType === 'password')
            this.newPasswordType = 'text';
        else
            this.newPasswordType = 'password';
    }

    onErrorMessageClick(): void {
        this.isShowError = false;
    }
    onSuccessMessageClick(): void {
        this.isShowSuccess = false;
    }

    showError(): void {
        this.isShowError = true;
    }
    showSuccess(): void {
        this.isShowError = false;
        this.isShowSuccess = true;
    }

    codeChange(code: string): void {
        console.log(code);
        this.code = code;
    }

    submit(): void {
        console.log(this.loginForm.value);
        let data = { ...this.loginForm.value, culture: this.culture };
        this.returnUrl = this.elementRef.nativeElement.getAttribute('returnUrl');
        data['return_url'] = this.returnUrl;
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/LoginGroupApi", data)
            .subscribe(d => {
                console.log(d);
                let result: IApiResultObject = d as IApiResultObject;
                if (result.status == true) {
                    this.showSuccess();
                    window.location = result.data;
                } 
                else
                    this.showError();
            });
    }

    submitRecover(): void {
        let data = {
            culture: this.culture,
            email: this.recoverForm.value.UserName
        };
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/PostResetPassword", data)
            .subscribe(d => {
                console.log(d);
                let result: IApiResultObject = d as IApiResultObject;
                if (result.status == true) {
                    console.log('success reset');
                }
                else
                    console.log('error reset ' + result.data);
                this.isRecoverFormSuccess = true;
            });
    }

    submitCkeckCode(): void {
        let data = {
            id: this.sendCodeResult.data,
            phone: this.phone,
            code: this.code

        };
        this.isShowCodeInvalidCountError = false;
        this.isShowCodeInvalidError = false;
        this.isShowCodeTryLaterError = false;
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/ResetPasswordCheckCode", data)
            .subscribe(d => {
                console.log(d);
                this.checkCodeResult = d as IApiResultObject;
                if (this.checkCodeResult.status == true) {
                    this.goToSetPassword();
                }
                else {
                    if (this.checkCodeResult.data == -2)
                        this.isShowCodeInvalidCountError = true;
                    else if (this.checkCodeResult.data == 0)
                        this.isShowCodeInvalidError = true;
                    else
                        this.isShowCodeTryLaterError = true;
                }
            });
    }

    newPasswordSubmit(): void {
        let data = {
            token: this.checkCodeResult.message,
            password: this.newPasswordForm.value.Password

        };
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/ResetPasswordSetNew", data)
            .subscribe(d => {
                console.log(d);
                let result: IApiResultObject = d as IApiResultObject;
                if (result.status == true) {
                    console.log('success reset');
                    this.goTologin();
                }
                else {
                    console.log('error reset ' + this.sendCodeResult.data);
                }
            });
    }
    
}